import React, { useContext, useEffect, useState } from 'react';
import './AdminPage.css';
import { UserContext } from '../../Contexts/UserContext';

const AdminPage = () => {
  // Dummy data
  const [users, setUsers] = useState([
    { email: 'john@example.com', isVideographer: false },
    { email: 'jane@example.com', isVideographer: true },
    { email: 'mark@example.com', isVideographer: false },
  ]);

  const [listings, setListings] = useState([
    { companyName: 'Apple' },
    { companyName: 'Google' },
    { companyName: 'Amazon' },
  ]);
  const { userInfo, setUserInfo } = useContext(UserContext);

  // State for selected user
  const [selectedUser, setSelectedUser] = useState(null);
  // State for selected listing
  const [selectedListing, setSelectedListing] = useState('');
  // Modal control states
  const [showModal, setShowModal] = useState(false);
  const [newListingName, setNewListingName] = useState('');

  //useEffect to fetch all users from the server. the endpoint is /api/getAllUsers
  useEffect(()=>{
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
    fetch(`${API_BASE_URL}/api/getAllUsers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
      },
    })
      .then(response => response.json())
      .then(data => {
        setUsers(data)
      })
      .catch(error => {
        console.error('Error getting listings:', error);
      });
  },[])

  //useEffect to fetch all listings from the server. the endpoint is /api/getAllListings
    useEffect(()=>{
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
    fetch(`${API_BASE_URL}/api/getAllListings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
      },
    })
      .then(response => response.json())
      .then(data => {
        setListings(data)
      })
      .catch(error => {
        console.error('Error getting listings', error);
      });
    },[])
  
    //useEffect to set selected listing to match the the name of the listing within listings that matches the listingId of the selected user but only if that user's isVideoGrapher is true
    useEffect(()=>{
      if(selectedUser?.isVideographer){
        const foundListing = listings.find((listing) => listing._id === selectedUser.listingId);
        console.log('Selected User:', selectedUser);
        console.log('Found Listing:', foundListing);
        setSelectedListing(foundListing?.companyName || '');
      }
    },[selectedUser])


  // Handle user selection
  const handleUserChange = (e) => {
    const selectedEmail = e.target.value;
    const foundUser = users.find((user) => user.email === selectedEmail);
    setSelectedUser(foundUser);
  };

  // Handle checkbox for “Is Videographer?”
  const handleVideographerChange = (e) => {
    if (!selectedUser) return;
    const updatedUser = {
      ...selectedUser,
      isVideographer: e.target.checked,
    };
    setSelectedUser(updatedUser);
  };

  // Open the "Add Listing" modal
  const handleOpenModal = () => {
    setShowModal(true);
  };

  // Close the modal without adding
  const handleCancelModal = () => {
    setShowModal(false);
    setNewListingName('');
  };

  // Add a new listing to state
const handleAddListing = async () => {
    if (newListingName.trim() !== '' && selectedUser) {
        const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
        try {
            const response = await fetch(`${API_BASE_URL}/api/adminAddListing`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
                },
                body: JSON.stringify({
                    companyName: newListingName.trim(),
                    ownerUserId: selectedUser._id,
                }),
            });

            if (response.ok) {
                const newListing = await response.json();
                console.log(newListing);
                setListings((prevListings) => [...prevListings, newListing]);
            } else {
                console.error('Failed to add listing');
            }
        } catch (error) {
            console.error('Error adding listing:', error);
        }
    }
    setNewListingName('');
    setShowModal(false);
};

  // Handle listing selection
  const handleListingChange = (e) => {
    setSelectedListing(e.target.value);
  };

  // “Save” updates the user data in the users array
const handleSave = async () => {
    if (!selectedUser) return;

    const updatedUsers = users.map((u) =>
        u.email === selectedUser.email ? selectedUser : u
    );

    setUsers(updatedUsers);

    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    try {
        const response = await fetch(`${API_BASE_URL}/api/adminSaveUser`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({
                email: selectedUser.email,
                isVideographer: selectedUser.isVideographer,
                listingId: listings.find((listing) => listing.companyName === selectedListing)?._id || null,
            }),
        });

        if (response.ok) {
            alert('User data saved successfully!');
        } else {
            console.error('Failed to save user data');
        }
    } catch (error) {
        console.error('Error saving user data:', error);
    }
};
  if(userInfo?.isAdmin !== true){
    return(
      <div>
        <h1>Access Denied</h1>
      </div>
    )
  }
    return (
      <div>

            
    <div className="admin-container">
      <h1>Admin Portal</h1>

      {/* Select User */}
      <div className="form-group">
        <label>Select User:</label>
        <select onChange={handleUserChange} value={selectedUser?.email || ''}>
          <option value="">-- Select a User --</option>
          {users.map((user) => (
            <option key={user.email} value={user.email}>
              {user.email}
            </option>
          ))}
        </select>
      </div>

      {/* Videographer Checkbox */}
      {selectedUser && (
        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              checked={selectedUser.isVideographer}
              onChange={handleVideographerChange}
            />
            Is Videographer?
          </label>
        </div>
      )}

      {/* If user is a videographer, show listing dropdown and add listing button */}
      {selectedUser?.isVideographer && (
        <>
          <div className="form-group">
            <label htmlFor="listingSelect">Select Listing:</label>
            <select
              id="listingSelect"
              onChange={handleListingChange}
              value={selectedListing}
            >
              <option value="">-- Select a Listing --</option>
              {listings.map((listing, index) => (
                <option key={index} value={listing.companyName}>
                  {listing.companyName}
                </option>
              ))}
            </select>
          </div>

          <button className="add-listing-btn" onClick={handleOpenModal}>
            Add Listing
          </button>
        </>
      )}

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Enter Company Name</h2>
            <input
              type="text"
              value={newListingName}
              onChange={(e) => setNewListingName(e.target.value)}
              placeholder="New Listing Name"
            />
            <div className="modal-buttons">
              <button onClick={handleCancelModal}>Cancel</button>
              <button onClick={handleAddListing}>Add Listing</button>
            </div>
          </div>
        </div>
      )}

      {/* Save Button */}
      <button className="save-btn" onClick={handleSave}>
        Save
      </button>
    </div>
    </div>
  ) ;
};

export default AdminPage;
